import { ActionTypes } from "../actions/adminUser";

const defaultState = {
  adminUsers: [],
};

export default function adminUserReducer(state = defaultState, action) {
  switch (action.type) {
    case ActionTypes.SET_ADMINUSERS:
      return { ...state, adminUsers: action.payload };

    // case ActionTypes.GET_ADMINUSERS:

    default:
      return state;
  }
}
